<script>
import {API2_PUBLIC_URL} from "api-client";
import axios from "axios";

export default {
  name: "RegistrationRedirect",
  data() {
    return {
      status: undefined
    }
  },
  methods: {
    getId() {
      return this.$route.params.paymentRequestId;
    }
  },
  mounted() {
    const url = API2_PUBLIC_URL + `/status-of-registration/${this.$route.query.paymentRequestId}`

    axios.get(url)
      .then(resp => {
        this.status = resp.data;
      })
      .catch(err => {
        console.error(err);
        this.$toast.error({
          title: this.$cte("common.error"),
          message: this.$cte("common.error"),
        });
      });
  }
}

</script>

<template>
  <div>
    <b-container>
      <b-card class="w-75 mx-auto mt-5 text-center shadow-lg">
        <div class="pt-5" v-if="!status">
          <h2 class="text-center mt-5 mb-5">Ellenőrzés...</h2>
        </div>
        <div class="pt-5" v-if="status === 'REGISTERED'">
          <i class="fas fa-check-circle text-success" style="font-size: 122px;"></i>
          <h2 class="text-center mt-5 mb-5">Bankkártyád megadása sikeres volt!</h2>
        </div>
        <div class="pt-5" v-if="status && status !== 'REGISTERED'">
<!--          <i class="fas fa-exclamation-circle text-danger" style="font-size: 122px;"></i>-->
          <h2 class="text-center mt-5 mb-5">Hiba!</h2>
        </div>
        <a href="/app/home" class="btn btn-success text-white">Visszatérés az oldalra</a>
      </b-card>
    </b-container>
  </div>
</template>

<style scoped>

</style>